"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardType;
(function (CardType) {
    CardType[CardType["DVA"] = 1] = "DVA";
    CardType[CardType["Medicare"] = 2] = "Medicare";
    CardType[CardType["Pension"] = 3] = "Pension";
})(CardType = exports.CardType || (exports.CardType = {}));
